<template>
  <section class="views">
    <!-- header -->
    <headers select="3"></headers>

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="
          require(`@/assets/image/hodgepodge/pcbanner_${this.$i18n.locale}.jpg`)
        "
      />
    </div>

    <div class="content">
      <div class="viewsBoxTab">
        <div class="viewsTab">
          <ul>
            <li
              v-for="(item, index) in tabColumns"
              :key="index"
              @click="tabBut(index)"
              :class="select == index ? 'select' : ''"
            >
              <div>{{ item.name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="shortlisted-query" v-if="false">
        <div class="contentFrom_title">{{ $t('achievement.shortlist_inquiry') }}</div>
        <div class="plateUlsCentent6">
          <ul>
            <li>
              <div class="promptInput">
                  <CountryCodeSelector
                    :searchbar="false"
                    :countryCode.sync="prefix"
                    style="width: 80px; margin-right: 10px"
                  ></CountryCodeSelector>
                  <input
                    type="text"
                    :placeholder="$t('achievement.enter_tel_join')"
                    value=""
                    v-model.trim="from.phone"
                  />
              </div>
            </li>
            <li>
              <div class="promptInput">
                <input
                  :placeholder="$t('achievement.enter_name')"
                  v-model="from.school_name"
                />
              </div>
            </li>

            <li style="width: 20%">
              <div class="but" @click="finalistsBut ? onFinalists() : ''">
                {{ $t('achievement.search') }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="viewTabContent">
        <div class="ulsTab" ref="tabSlideTwo">
          <ul>
            <li
              v-for="(item, index) in tabColumns[select].dataTab"
              :key="index"
              :class="selectTwo == index ? 'select' : ''"
              @click="tabButTwo(index)"
              :ref="`tab${index}RefTwo`"
            >
              <div>{{ item.name }}</div>
              <div>（{{ item.fzhu }}）</div>
            </li>
          </ul>
        </div>

        <div class="box">
          <ul v-if="true">
            <div class="wu">
              <img :src="require('@/assets/image/hodgepodge/wu.png')" alt="" />
              <span> {{ $t('other_pages.no_results_yet') }} </span>
            </div>
          </ul>
          <!-- <ul v-if="select == 1 && selectTwo == 6">
            <li class="weiyitop">
              <div>{{ $t('achievement.join_no') }}</div>
              <div>{{ $t('achievement.name') }}</div>
              <div>{{ $t('achievement.phone') }}</div>
              <div>{{ $t('achievement.status_awards')}}</div>
            </li>
            <li class="lis" v-for="(item, index) in queryUserList" :key="index">
              <div>{{ item.competitionId }}</div>
              <div>{{ item.studentName }}</div>
              <div>{{ item.studentCode || item.phone }}</div>
              <div>
                {{ index < 3 ? $t('achievement.for_finals') : index > 2 ? $t('excellence_award') : "" }}
              </div>
            </li>
          </ul> -->
          <!-- <ul v-if="select == 2">
            <li class="weiyitop">
              <div>{{ $t('achievement.join_no') }}</div>
              <div>{{ $t('achievement.name') }}</div>
              <div>{{ $t('achievement.awards') }}</div>
            </li>

            <li class="lis" v-for="(item, index) in queryUserList" :key="index">
              <div>{{ item.competitionId }}</div>
              <div>{{ item.studentName }}</div>
              <div v-if="item.ranking">{{ $t(`achievement.ranking_${item.ranking}`) }}</div>
            </li>
          </ul> -->
          <!-- <ul v-else>
            <li class="weiyitop">
              <div>{{ $t('achievement.join_no') }}</div>
              <div>{{ $t('achievement.name') }}</div>
              <div>{{ $t('achievement.phone') }}</div>
            </li>

            <li class="lis" v-for="(item, index) in queryUserList" :key="index">
              <div>{{ item.competitionId }}</div>
              <div>{{ item.studentName }}</div>
              <div>{{ item.studentCode || item.phone }}</div>
            </li>
          </ul> -->
        </div>
      </div>

      <!-- 佔位 -->
      <div style="margin-top: 20px; width: 100%"></div>
    </div>

    <!-- 未入圍/成功入園 -->
    <van-popup v-model="newShortZZC" :round="true" :lock-scroll="false">
      <div class="newShortBox">
        <div class="list" v-if="newShortActive == 1">
          <!-- <div class="lis lisCenten"> <van-image width="149px" :src="require('@/assets/image/fusai/yes.png')" /> </div> -->
          <div class="ulst">
            <ul>
              <li>{{ $t('achievement.name') }}</li>
              <li>{{ $t('achievement.group') }}</li>
              <li>{{ $t('achievement.score') }}</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText" v-if="select == 0" v-html="$t('achievement.join_success')"></div>
          <div class="lis lisText" v-if="select == 1">
            <span v-if="userObj.finalStatus == 1" v-html="$t('achievement.final_join_fail')"></span>
            <span v-else v-html="$t('achievement.final_join_success')"></span>
          </div>
          <div
            class="view_guide"
            @click="generateHeatsZZC = true"
            v-if="select == 0"
          >
          {{ $t('achievement.see_semi_rule') }}
          </div>
        </div>

        <div class="list" style="padding: 10px 0" v-if="newShortActive == 2">
          <div class="ulst">
            <ul>
              <li>{{ $t('achievement.name') }}</li>
              <li>{{ $t('achievement.group') }}</li>
              <li>{{ $t('achievement.score') }}</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText" v-if="select == 0" v-html="$t('achievement.join_fail')"></div>
          <div class="lis lisText" v-if="select == 1" v-html="$t('achievement.final_join_fail')"></div>
        </div>
      </div>
    </van-popup>
    <!-- 複賽指引 -->
    <div class="generateHeats">
      <van-popup v-model="generateHeatsZZC" :round="true" :lock-scroll="false">
        <div class="generateHeatsBox">
          <div class="uls">
            <div class="titleH1">
              <div class="left_icon">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="title">{{ $t('semi_rematch.semi_rule_title') }}</div>
              <div class="right_icon">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <div class="textCentent">
              <div class="color1 font_size1" style="margin-bottom: 6px">
                {{ $t('semi_rematch.semi_rule_info') }}
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                {{ $t('semi_rematch.semi_rule_txt_1') }}
                <br />
                {{ $t('semi_rematch.semi_rule_txt_2') }}
                <br />
                {{ $t('semi_rematch.semi_rule_txt_3') }}
                <br />
              </div>
              <div class="titleRed">{{ $t('semi_rematch.semi_rule_title_1') }}</div>
              <div class="color1 font_size1" style="margin-bottom: 6px">
                1. {{ $t('semi_rematch.semi_rule_info_1_1') }}
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ①
                {{ $t('semi_rematch.semi_rule_txt_1_1_1') }}
                <br />
                ②
                {{ $t('semi_rematch.semi_rule_txt_1_1_2') }}
                <br />
                ③ {{ $t('semi_rematch.semi_rule_txt_1_1_3') }}
                <br />
                ④ {{ $t('semi_rematch.semi_rule_txt_1_1_4') }}
                <br />
                ⑤ {{ $t('semi_rematch.semi_rule_txt_1_1_5') }}
                <br />
                ⑥ {{ $t('semi_rematch.semi_rule_txt_1_1_6') }}
                <br />
                ⑦ {{ $t('semi_rematch.semi_rule_txt_1_1_7') }}
                <br />
              </div>
              <div class="color1 font_size1" style="margin-bottom: 6px">
                2. {{ $t('semi_rematch.semi_rule_info_1_2') }}
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ① {{ $t('semi_rematch.semi_rule_txt_2_1') }}
                <br />
                ② {{ $t('semi_rematch.semi_rule_txt_2_2') }}
                <br />
                ③
                {{ $t('semi_rematch.semi_rule_txt_2_3') }}
                <br />
                ④
                {{ $t('semi_rematch.semi_rule_txt_2_4') }}
                <br />
                ⑤
                {{ $t('semi_rematch.semi_rule_txt_2_5') }}
                <br />
                ⑥ {{ $t('semi_rematch.semi_rule_txt_2_6') }}
                <br />
                ⑦ {{ $t('semi_rematch.semi_rule_txt_2_7') }}
                <br />
              </div>

              <div class="color1 font_size1" style="margin-bottom: 6px">
                3. {{ $t('semi_rematch.semi_rule_info_1_3') }}
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ① {{ $t('semi_rematch.semi_rule_txt_3_1') }}
                <br />
                ②
                {{ $t('semi_rematch.semi_rule_txt_3_2') }}
                <br />
                ③ {{ $t('semi_rematch.semi_rule_txt_3_3') }}
                <br />
              </div>
              <div class="titleRed">{{ $t('semi_rematch.semi_rule_title_2') }}</div>
              <div class="font_size2" style="margin-bottom: 20px">
                <span class="color1"
                  >① {{ $t('semi_rematch.semi_rule_info_2_1') }}</span
                >
                <br />
                <span class="color1"
                  >② {{ $t('semi_rematch.semi_rule_info_2_2') }}</span
                >
                <br />
                <span class="color2">
                  {{ $t('semi_rematch.semi_rule_txt_2_2_1') }}
                </span>
                <br />
                <span class="color2"
                  >{{ $t('semi_rematch.semi_rule_txt_2_2_2') }}</span
                >
                <br />
                <span class="color1"
                  >③ {{ $t('semi_rematch.semi_rule_txt_2_2_3') }}</span
                >
                <br />
                <span class="color1"
                  >④
                  {{ $t('semi_rematch.semi_rule_txt_2_2_4') }}</span
                >
                <br />
                <span class="color1"
                  >⑤
                  {{ $t('semi_rematch.semi_rule_txt_2_2_5') }}</span
                >
                <br />
              </div>
              <!-- TODO:0401 -->
              <!-- <div class="but" style="filter: grayscale(1);" @click="handleUploadVideo()">
                <img :src="require('@/assets/image/fusai/yunshang.png')" />
                {{ $t('achievement.click_upload_video') }}
              </div> -->
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import CountryCodeSelector from "@/components/CountryCodeSelector";
export default {
  name: "signup",
  data() {
    return {
      tabColumns: [
        {
          id: "0",
          name: this.$t("other_pages.preliminary_results"),
          dataTab: [
            {
              name: this.$t("achievement.group_a_text"),
              fzhu: this.$t("achievement.group_a_age"),
            },
            {
              name: this.$t("achievement.group_b_text"),
              fzhu: this.$t("achievement.group_b_age"),
            },
            {
              name: this.$t("achievement.group_c_text"),
              fzhu: this.$t("achievement.group_c_age"),
            },
          ],
        },
        {
          id: "1",
          name: this.$t("other_pages.semifinal_results"),
          dataTab: [
          {
              name: this.$t("achievement.group_a_text"),
              fzhu: this.$t("achievement.group_a_age"),
            },
            {
              name: this.$t("achievement.group_b_text"),
              fzhu: this.$t("achievement.group_b_age"),
            },
            {
              name: this.$t("achievement.group_c_text"),
              fzhu: this.$t("achievement.group_c_age"),
            },
          ],
        },
        {
          id: "2",
          name: this.$t("other_pages.final_results"),
          dataTab: [
          {
              name: this.$t("achievement.group_a_text"),
              fzhu: this.$t("achievement.group_a_age"),
            },
            {
              name: this.$t("achievement.group_b_text"),
              fzhu: this.$t("achievement.group_b_age"),
            },
            {
              name: this.$t("achievement.group_c_text"),
              fzhu: this.$t("achievement.group_c_age"),
            },
          ],
        },
      ],
      select: 0,
      selectTwo: 0,
      from: {
        school_name: null,
        email: null,
        phone: null,
        schoolCode: null,
        studentCode: null,
        password: null,
      },
      prefix: 62,
      finalistsBut: true,
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1,
      userObj: {
        competitionGroup: 1, //組別
        score: null, //分數
        studentName: null, //名字
      },
      queryUserList: [],
      finalists: [],
      generateHeatsZZC: false,
    };
  },
  computed: {},
  components: {
    headers,
    CountryCodeSelector,
  },
  watch: {},
  created() {},
  mounted() {
    // this.getScoreList(1);
  },
  methods: {
    tabButTwo(e) {
      this.selectTwo = e;
      // this.getScoreList(1);
      // if (this.select != 2) {
      //   this.getScoreList(1);
      // } else {
      //   this.queryUserList = [];
      //   let groupId = this.selectTwo + 1;
      //   this.finalists.forEach((item) => {
      //     if (item.group == groupId) {
      //       this.queryUserList = item.data;
      //     }
      //   });
      // }
    },
    tabBut(e) {
      this.select = e;
      // this.getScoreList(1);
      // if (this.select != 2) {
      //   this.getScoreList(1);
      // } else {
      //   this.queryUserList = [];
      //   let groupId = this.selectTwo + 1;
      //   this.finalists.forEach((item) => {
      //     if (item.group == groupId) {
      //       this.queryUserList = item.data;
      //     }
      //   });
      // }
    },
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    validator_phone(val) {
      const phone = val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 入圍按鈕提交
    onFinalists() {
      let params = {
        studentName: this.from.school_name,
        prefix: this.prefix,
        phone: this.from.phone,
        email: null,
      };

      if (params.studentName == "" || params.studentName == null) {
        this.$toast(this.$t("achievement.enter_name") + ' !');
        return;
      }
      // 手機
      if (!this.validator_phone(params.phone)) {
        this.$toast(this.$t("achievement.phone_format_err") + ' !');
        return;
      }
      params.scoreType = this.select + 1;

      this.finalistsBut = false;
      this.$toast.loading({
        message: this.$t("achievement.querying"),
        duration: 0,
        forbidClick: true,
      });
      
      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.finalistsBut = true;
          console.log(response);
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            const {
              competitionGroup,
              score,
              studentName,
              shortlisted,
              finalStatus,
              groupId,
            } = response.data.data;
            this.userObj.competitionGroup = competitionGroup; //組別
            this.userObj.score = score; //分數
            this.userObj.studentName = studentName; //名字
            this.userObj.finalStatus = finalStatus; // 1是优异奖  2是入围决赛

            this.$toast.clear();
            if (shortlisted || groupId == 7) {
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 1; //1是成功  2是失敗
            } else {
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.finalistsBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getScoreList(pageNum) {
      this.$toast.loading({
        message: this.$t("achievement.querying"),
        duration: 0,
        forbidClick: true,
      });
      let groupId = this.selectTwo + 1;
      let scoreType = this.select + 1;
      let params =
        "?groupId=" +
        groupId +
        "&scoreType=" +
        scoreType +
        "&pageNum=" +
        pageNum +
        "&pageSize=" +
        100;
      if (this.select == 1) {
        params = params + "&ranking=" + 10;
      }
      this.$axios
        .get(this.$api.promotionStudentList + params)
        .then((response) => {
          this.$toast.clear();
          let arr = response.data.rows;
          if (pageNum === 1) {
            this.queryUserList = arr;
          } else {
            this.queryUserList = [...this.queryUserList, ...arr];
          }
          // 数据最多返回100条，超出请求2次
          if (response.data.total > 100 && pageNum === 1) {
            this.getScoreList(2);
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    handleUploadVideo() {
      // TODO: 0328
      this.$dialog
      .alert({
        title: '',
        message: this.$t('achievement.semi_ended'),
        confirmButtonText: this.$t('other_pages.confirm')
      })
      .then(() => {
        // on close
      })
      return;
      // this.$router.push({
      //   path: "/",
      //   query: {
      //     uploadVideo: true,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 19px;
            text-align: center;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    margin: auto;

    .viewsBoxTab {
      width: 100%;
      position: relative;
      background: #d34a00;

      .viewsTab {
        width: 100%;
        max-width: 1024px;
        margin: auto;
        box-sizing: border-box;
        display: flex;

        ul {
          width: 100%;
          height: 64px;
          display: inline-flex;
          justify-content: center;
          align-items: center;

          li {
            min-width: 150px;
            padding: 0 20px;
            height: 100%;
            display: flex;
            align-content: center;
            align-items: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            flex: 0 0 auto;
            background: #d34a00;
            cursor: pointer;

            div {
              width: 100%;
            }

            div:nth-child(1) {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 0.33rem;
            }

            div:nth-child(2) {
              font-size: 11px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 13px;
            }
          }

          .select {
            font-size: 16px;
            font-weight: 600;
            color: #903300;
            padding: 12px;
            background: url("~@/assets/image/hodgepodge/tabbuttom.png")
              no-repeat;
            background-size: 100% 100%;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #903300;
              line-height: 16px !important;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #903300;
              line-height: 15.5px !important;
            }
          }
        }
      }
    }

    .viewTabContent {
      width: 100%;
      max-width: 1024px;
      margin: auto;
      margin-top: 36px;
      box-sizing: border-box;

      .ulsTab::-webkit-scrollbar {
        display: none;
      }

      .ulsTab {
        width: 100%;
        box-sizing: border-box;

        ul {
          width: 100%;
          display: inline-flex;
          justify-content: center;
          align-items: center;

          li {
            margin: 0 auto;
            // margin-right: 38px;
            width: 30%;
            height: 66px;
            background: #ffffff;
            border: 2px solid #ffffff;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            line-height: 19px;
            text-align: center;
            border-radius: 16px;
            cursor: pointer;

            div:nth-child(1) {
              width: 100%;
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              color: #666666;
              line-height: 19px;
            }

            div:nth-child(2) {
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              color: #666666;
              margin-top: 2px;
            }
          }
          .select {
            background: #fdd472 !important;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #903300 !important;
              line-height: 19px;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #903300 !important;
            }
          }
        }
      }

      .box {
        width: 700px;
        padding-top: 64px;
        margin: auto;
        box-sizing: border-box;

        ul::-webkit-scrollbar {
          display: none;
        }

        ul {
          width: 100%;
          height: 70vh;
          border-radius: 16px;
          background: #ffffff;
          border: 0.06rem solid #ffffff;
          box-sizing: border-box;
          overflow-x: hidden;
          position: relative;

          .wei {
            width: 100%;
            height: 46px;
          }

          .weiyitop {
            width: 100%;
            height: 46px;
            background: #ffb559;
            display: flex;
            position: sticky;
            left: 0;
            top: 0;

            div {
              width: 33%;
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #a94800;
              line-height: 46px;
            }
          }

          .lis {
            width: 100%;
            height: 46px;
            margin: auto;
            background: #ffffff;
            display: flex;
            border-bottom: 1px;

            div {
              width: 33%;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 46px;
              text-align: center;
            }
          }

          .wu {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            align-content: center;

            img {
              width: 200px;
              margin-bottom: 30px;
            }

            span {
              width: 100%;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
.shortlisted-query {
  width: 100%;
  max-width: 1024px;
  margin: 70px auto 0 auto;
  position: relative;
  .contentFrom_title {
    width: 300px;;
    height: 55px;
    margin: auto;
    border-radius: 9px;
    background: url("~@/assets/image/icon/titlebg.png") no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 55px;
    position: absolute;
    top: -26px;
    left: 0;
    right: 0;
    margin: auto;

    text-shadow: 1.5px 1.5px 0 #ff782f, -1.5px 1.5px 0 #ff782f,
      1.5px -1.5px 0 #ff782f, -1.5px -1.5px 0 #ff782f;
  }
  .plateUlsCentent6 {
    width: 100%;
    padding: 35px 7px 20px 7px;
    border-radius: 8px 8px 8px 8px;
    box-sizing: border-box;
    background: #ffffff;

    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: flex-end;
      box-sizing: border-box;
      li {
        width: 30%;
        text-align: left;

        .prompt {
          height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          margin-bottom: 12px;
          // padding-left: 13px;
          // box-sizing: border-box;
          display: flex;
          align-items: center;
          padding-left: 13px;
          box-sizing: border-box;

          div {
            margin-right: 11px;
            text-align: center;
            line-height: 30px;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: " ";
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            font-size: 12px !important;
            color: #de2810;
          }
        }

        
        .lisLife {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4a4a4a;
          padding-left: 10px;
          box-sizing: border-box;

          img {
            width: 16px;
            height: 11px;
          }
        }

        .promptInput {
          width: 100%;
          height: 34px;
          display: flex;
          align-items: center;
          padding-left: 15px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 3px 3px 3px 3px;
          input {
            width: 100%;
            height: 100%;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            background: #f5f5f5;
            border-radius: 3px 3px 3px 3px;
            border: none;
            box-sizing: border-box;
          }

          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }
      }

      // li:last-child {
      //   margin-top: 15px;
      // }
    }

    .uls:first-child {
      margin-right: 60px;
    }

    .but {
      width: 140px;
      height: 52px;
      background: url("~@/assets/image/icon/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 52px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      margin: 0 auto;
      cursor: pointer;
      transition: all 0.3s;
      letter-spacing: 2px;
      &:active {
        transform: scale(1.06);
      }
    }
  }
}
.newShortBox {
  width: 600px;
  height: 300px;
  padding-top: 24px;
  padding-bottom: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: center;

    .lis {
      width: 100%;
      margin-bottom: 20px;
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 65%;
      margin: auto;
      font-size: 14px;

      span {
        color: #ff5a25;
      }
    }

    .ulst {
      width: 80%;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 3px 3px 3px 3px;

        li {
          width: 32%;
          text-align: center;
          font-size: 14px;
          padding: 0 5px;
        }
        li:nth-child(2) {
          width: 36% !important;
        }
      }

      ul:nth-child(1) {
        background: #ff5a25;
        height: 30px;
        line-height: 30px;

        li {
          height: 100%;
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        font-size: 9.8px !important;
        line-height: 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        padding: 10px 0;
        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 24px;
    }

    .but {
      width: 140px;
      height: 40px;
      background: url("~@/assets/image/icon/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin: auto;
    }
  }
}
::v-deep .CountryCodeSelectorContainer {
  width: 100px;
  .arrow-down {
    width: 12px;
    height: 12px;
  }
}
.generateHeatsBox {
  width: 960px;
  padding: 12px;
  box-sizing: border-box;
  background: #ffd123;
  border-radius: 16px 16px 16px 16px;
  .uls {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    background: #fff;

    .titleH1 {
      width: 100%;
      font-size: 24px;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 0 15px 0;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:first-child {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
      }
    }

    .textCentent {
      width: 100%;
      text-align: left;
      line-height: 1.5;
      font-family: PingFang SC-Medium, PingFang SC;

      .color1 {
        color: #ff5a25;
      }
      .color2 {
        color: #999999;
      }

      .font_size1 {
        font-size: 18px;
      }
      .font_size2 {
        font-size: 14px;
      }

      .titleRed {
        display: inline-block;
        padding: 12px 16px;
        background: #ff5a25;
        border-radius: 3px 3px 3px 3px;
        text-align: center;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 12px;
      }

      .but {
        width: 360px;
        padding: 10px;
        margin: 50px auto 20px;
        background: #ff7e18;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
      }
    }
  }
}
.generateHeats {
  .van-popup {
    z-index: 999999 !important;
  }
}
.view_guide {
  padding: 12px 15px;
  background: #ff7e18;
  font-size: 20px;
  font-family: PingFang SC-Semibold, PingFang SC;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  // margin: auto;
  cursor: pointer;
}
</style>
